import { HttpInterceptorFn, HttpErrorResponse, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { AuthService } from '../_services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/auth/refresh')) {
        return handle401(req, next, authService, router);
      }

      if (error.status === 403) {
        authService.clearSession(); // ✅ now public — no more ['clearSession']
      }

      return throwError(() => error);
    })
  );
};

function handle401(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  authService: AuthService,
  router: Router
): Observable<any> {
  if (!authService.isRefreshingToken) {
    authService.setRefreshing(true);
    authService.refreshSubject.next(null);

    return authService.refreshTokens().pipe(
      switchMap((res) => {
        authService.setRefreshing(false);
        return next(
          req.clone({ setHeaders: { Authorization: `Bearer ${res.accessToken}` } })
        );
      }),
      catchError((err) => {
        authService.setRefreshing(false);
        authService.clearSession();
        return throwError(() => err);
      })
    );
  }

  return authService.refreshSubject.pipe(
    filter((token) => token !== null),
    take(1),
    switchMap((token) =>
      next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }))
    )
  );
}